<template>
  <div>
    <TableList
      style="width: 100%; margin-top: 10px"
      :columns="columns"
      :tableData="tableData"
      :loading="loading"
      :scroll="{}"
      :pagination="ipagination"
      @change="handleTableChange"
    >
      <div slot="queryArea" class="query-area">
        <div>
          <a-select
            placeholder="请选择量表"
            v-model="queryParam.evaluationId"
            style="width: 170px; margin-right: 15px"
            :options="evaluationOptions"
          />
          <j-dict-select-tag
            style="width: 170px; margin-right: 15px"
            placeholder="请选择年级"
            v-model="queryParam.gradeId"
            dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
            :optionalVals="viewRecord.gradeIds"
            :allowClear="false"
            :isShowEmpty="false"
          />
          <j-dict-select-tag
            style="width: 170px; margin-right: 15px"
            placeholder="请选择班级"
            v-model="queryParam.classId"
            :dictCode="
              'school_class,name,id,grade_id=' + (!queryParam.gradeId ? -1 : queryParam.gradeId)
            "
            :optionalVals="viewRecord.classIds"
            :async="true"
            :disabled="!queryParam.gradeId"
            :isShowEmpty="false"
          />
          <a-input-search
            v-model="queryParam.studentName"
            placeholder="请输入学生名字"
            class="search-space"
            style="width: 170px"
            @change="searchName"
          />
          <a-button type="primary" @click="loadData">查询</a-button>
        </div>
        <a-button
          type="primary"
          icon="download"
          style="margin-left: auto"
          @click="handleExportXls('测评结果')"
        >
          导出测评结果
        </a-button>
      </div>
      <template #action="{ record }">
        <span
          style="margin-right: 10px; color: #1783e8; cursor: pointer"
          @click="viewReport(record)"
        >
          查看报告
        </span>
        <span style="color: #1783e8; cursor: pointer" @click="viewRecordModal(record)">
          测评记录
        </span>
      </template>
    </TableList>
    <!--    数据报告-->
    <DetailedReport ref="detailedReportRef" />
    <EvalPreviewModal ref="evalPreviewModalRef" />
  </div>
</template>
<script>
import TableList from '@/components/chart/TableList'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getAction } from '@api/manage'
import { simpleDebounce } from '@/utils/util'
import DetailedReport from '@/comUi/ArchivesView/components/DetailedReport'
import EvalPreviewModal from './EvalPreviewModal.vue'

export default {
  name: 'ReportAnalysis',
  components: { TableList, DetailedReport, EvalPreviewModal },
  mixins: [JeecgListMixin],
  props: {
    viewRecord: {
      type: Object,
      default: () => ({}),
    },
  },
  disableMixinCreated: true,
  data() {
    return {
      columns: [
        {
          scopedSlots: { customRender: 'action' },
        },
      ],
      tableData: [],
      loading: false,
      url: {
        list: '/schoolEvaluationRecord/evaluationResult',
        exportXlsUrl: '/schoolEvaluationRecord/evaluationResultExport',
      },
      evaluationOptions: [],
      disableMixinCreated: true,
    }
  },
  created() {
    // console.log('初始化数据分析：', this.viewRecord)
    this.$set(this.queryParam, 'planId', this.viewRecord.id)
    this.getEvaluationByPlanId()
  },
  methods: {
    searchName: simpleDebounce(function (event) {
      const name = event.target.value
      this.$set(this.queryParam, 'studentName', name || undefined)
      this.loadData()
    }, 500),
    async loadData() {
      this.loading = true
      const res = await getAction(this.url.list, {
        ...this.queryParam,
        pageSize: this.ipagination.pageSize,
        pageNo: this.ipagination.current,
      })
      if (res.success) {
        this.columns = [
          ...(res.result.columns.map((item) => ({
            title: item,
            dataIndex: item,
            align: 'center',
          })) || []),
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            scopedSlots: { customRender: 'action' },
          },
        ]
        this.tableData = res.result.data
        this.$set(this.ipagination, 'total', res.result.total)
        this.$forceUpdate()
      }
      this.loading = false
    },
    async getEvaluationByPlanId() {
      const res = await getAction('/schoolEvaluationPlan/getEvaluationByPlanId', {
        planId: this.viewRecord.id,
        // ...this.queryParam,
      })
      if (res.success) {
        this.evaluationOptions = res.result.map((item) => ({
          value: item.id,
          label: item.name,
        }))
        this.$set(this.queryParam, 'evaluationId', this.evaluationOptions[0].value)
        this.loadData()
      }
      console.log('量表--', res)
    },
    viewReport(record) {
      console.log('查看数据报告：', record)
      this.$refs.detailedReportRef.showModal(record)
    },
    viewRecordModal(data) {
      const record = {
        id: data.id,
        planId: this.viewRecord.id,
        evaluationId: this.queryParam.evaluationId,
      }
      console.log('查看测评记录：', record)
      this.$refs.evalPreviewModalRef.showModal(record)
    },
  },
}
</script>
<style scoped lang="less">
.query-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.action-detail {
  min-width: 100px !important;
  color: #0077fa !important;
  cursor: pointer !important;
}
.search-space {
  width: 140px;
  margin-right: 15px;
}
</style>
